// extracted by mini-css-extract-plugin
export default {"firstLine":"TwoLineGridCell_firstLine__6shcl","secondLine":"TwoLineGridCell_secondLine__qwg6J"};